<template>
  <div class="detailPage">
    <backgroundTop title="遵义医科大学附属医院" />
    <div class="content">
      <div class="title">{{ view.news_title }}</div>
      <el-divider></el-divider>
      <div class="publishDate">
        <span>发布时间：{{ view.public_time | formdate }}</span>
      </div>
      <div class="detailContent">
        <p v-html="view.news_content"></p>
      </div>
    </div>
  </div>
</template>
<script>
import backgroundTop from '../components/backgroundTop'

export default {
  components: {
    backgroundTop
  },
  data() {
    return {
      params: {
        id: ''
      },
      view: {
        rec_id: '',
        public_time: '',
        news_title: '',
        news_content: ''
      }
    }
  },
  filters: {
    formdate(val) {
      if (!val) return
      const date = val.slice(0, 10)
      const time = val.slice(11, 19)
      return date + ' ' + time
    }
  },
  created() {
    this.params.id = this.$route.query.id
    // console.log(this.params.id)
    this.getView()
  },
  methods: {
    getView() {
      this.$axios
        .get('api/news/view', {
          params: this.params
        })
        .then(result => {
          const { data: res} = result
          // console.log(res.data[0])
          this.view = res.data[0]
        })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../assets/style/mixin.scss';
.detailPage {
  .top {
    background-color: #086167;
    margin-bottom: 50px;
    .inner {
      @include autoInner();
      color: #fff;
      padding: 40px 0;
      p {
        font-size: 32px;
        color: #fff;
      }
      .loginR {
        color: #409eff;
      }
    }
  }
  .content {
    @include autoInner();
    .title {
      font-size: 24px;
      text-align: center;
      color: #5e5a6e;
    }
    .publishDate {
      text-align: center;
      color: #848488;
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
}
</style>
